import Cards from "../Cards";
import Contato from "../Contato";
import Footer from "../footer";
import Menu from "../Menu";
import { Mobile } from "../Mobile";
import { Slider } from "../Slider";
import { Sobre } from "../Sobre";
import { ContainerC } from "./styles";
import { ModalContato } from "../Modal";
import { RoutesR } from "../Routes";
import { Routes, Route, BrowserRouter } from "react-router-dom";

export const Content = () => {
  return (
    <ContainerC>
      <Menu />
      <Slider />
      <Mobile />
      <Sobre />
      <Cards />
      <Contato />
      <Footer />
    </ContainerC>
  );
};
